<template>
  <div class="page-container">
    <!-- 头部 -->
    <section>
      <com-header></com-header>
    </section>

    <!-- nav -->
    <section>
      <com-nav></com-nav>
    </section>

    <!-- 内容部分 -->
    <section>
      <div class="page-content">
        <div class="line-mask"></div>
        <div class="page-area">
          <div class="cont-item">
            <p class="font-big title">关于宝兰</p>
            <div class="img-box">
              <img src="../assets/about/1.jpg" alt="" />
            </div>
          </div>
          <div class="cont-item">
            <p class="font-middle dec">传承中华千年文化，匠心坚守御用工艺；</p>
            <p class="font-middle dec">
              传统时尚内外兼修，构建东方奢侈品牌，宝兰坚守中华匠心，
            </p>
            <p class="font-middle dec">传递古法手工金器，奋力挖掘、继承与发扬</p>
            <p class="font-middle dec">“花丝镶嵌”这门中华民族的“独门绝学”。</p>
          </div>
          <div class="cont-item">
            <p class="font-big title">附近门店</p>
            <div class="store-box">
              <div class="store-item">
                <div class="item-left"><img src="../assets/about/2.jpg" alt="" /></div>
                <div class="item-right">
                  <p class="store-name">杭州大厦</p>
                  <p class="store-dec">杭州大厦购物城D座2层</p>
                  <p class="store-dec">0571-88100099</p>
                </div>
              </div>
              <div class="store-item">
                <div class="item-left"><img src="../assets/about/3.jpg" alt="" /></div>
                <div class="item-right">
                  <p class="store-name">杭州万象城</p>
                  <p class="store-dec">杭州万象城B1层 B1127</p>
                  <p class="store-dec">0571-89705299</p>
                </div>
              </div>
              <div class="store-item">
                <div class="item-left"><img src="../assets/about/4.jpg" alt="" /></div>
                <div class="item-right">
                  <p class="store-name">杭州庆春银泰</p>
                  <p class="store-dec">杭州庆春银泰1层 1027</p>
                  <p class="store-dec">0571-86533301</p>
                </div>
              </div>
              <div class="store-item">
                <div class="item-left"><img src="../assets/about/5.jpg" alt="" /></div>
                <div class="item-right">
                  <p class="store-name">杭州宝兰黄金研究所</p>
                  <p class="store-dec">天目山路513号 2号楼</p>
                  <p class="store-dec">0571-88188168</p>
                </div>
              </div>
            </div>
          </div>
          <div class="cont-item">
            <div class="img-box qr-box">
              <img src="../assets/about/qr.jpg" alt="" />
            </div>
            <p class="follow-tip">关注了解更多</p>
            <p class="qr-dec qr-top-dec">每一刻，都值得珍藏。</p>
            <p class="qr-dec qr-dec-en">Cherish Every Moment & Gram.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import comHeader from "../components/comheader.vue";
import comNav from "../components/comnav.vue";
export default {
  name: "about",
  data() {
    return {};
  },
  components: {
    comHeader: comHeader,
    comNav: comNav,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.page-container {
  width: 100%;
  .page-content {
    position: relative;
    width: 100%;
    background-image: linear-gradient(180deg, #0a0020 0%, #534d63 100%);
    .line-mask {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
      background-image: url("../assets/indexbottomline.png");
      background-repeat: repeat-y;
      background-size: 100% auto;
      background-position: top left;
    }
    .page-area {
      position: relative;
      z-index: 1;
      padding: 220px 0;
      .cont-item {
        margin-bottom: 240px;
        color: #ffffff;
        text-align: center;
        &:last-child {
          margin-bottom: 0;
        }
        .dec {
          font-size: 16px;
          line-height: 80px;
          letter-spacing: 10px;
        }
        .title {
          margin-bottom: 80px;
          letter-spacing: 30px;
        }
        .qr-dec {
          margin:5px 0;
          color: #f4dba0;
          font-size: 14px;
          text-align: center;
          &.qr-dec-en {
            letter-spacing: 3px;
          }
          &.qr-top-dec {
            padding-left: 20px;
            font-size: 16px;
            letter-spacing:15px;
          }
        }
        .follow-tip {
          padding-left:5px;
          margin-bottom:100px;
          color: #ffffff;
          font-size: 14px;
          letter-spacing:10px;
        }
        .img-box {
          width: 80%;
          max-width: 1000px;
          margin: 220px auto 0 auto;
          cursor: pointer;
          img {
            width: 100%;
          }
          &.qr-box {
           margin-bottom: 20px;
            width: 135px;
            height: auto;
          }
        }
        .store-box {
          margin: 0 auto 0 auto;
          margin-top: 155px;
          width: 90%;
          max-width: 820px;
          .store-item {
            display: flex;
            padding: 23px 0;
            margin: 100px 0;
            width: 100%;
            background: #868291;
            cursor: pointer;
            .item-left {
              width: 45%;
              padding-left: 5%;
              img {
                width: 100%;
                height: auto;
              }
            }
            .item-right {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              flex: 1;
              color: #ffffff;
              .store-name {
                font-size: 26px;
                margin-bottom: 50px;
                letter-spacing:10px;
              }
              .store-dec {
                margin: 8px 0;
                font-size: 20px;
                letter-spacing:5px;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about.vue